<template>
    <!-- 工单视图列表 -->
    <div>
      <!-- 搜索框 -->
      <TicketSearchForm v-model="searchData"
        ref="ticketSearchForm"
        @search="doSearch"
        @reset="resetSearch"
        @export="doExport" />

      <!-- 工单列表 -->
      <ViewTicketTable :list="ticketList"
        :viewId="currentViewId"
        :tableEmptyPlaceholder="tableEmptyPlaceholder"
        @sort-change="tableSortChange_2"
        @selection-change="selectionChange"
        @after-close-ticket="queryTicketList" />

      <!-- 分页 -->
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :pager-count="9"
        :current-page="page.pageNumber" 
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" 
        :page-size="page.pageSize" 
        :total="recordCount || 0" 
        @size-change="handleSizeChange" 
        @current-change="queryTicketList" />

      <!-- 撑高 -->
      <div style="height:50px;"/>

      <!-- 批量操作条 -->
      <TicketBatchOperationBar ref="TicketBatchOperationBar"
        @cancel="queryTicketList"/>
    </div>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil';

var _defaultSearchData = {
  orderSuperType: this.id,
  orderTitle: '',
  orderStatus: [], //工单状态
  ticketCreateTimeBegin: '',
  ticketCreateTimeEnd: '',
  creatorId: '',
  orderType: '',
  dealUserId: '',
  orderPriority: ''
};

export default {
  name: "ViewTicketList",

  data() {
    return {
      tableEmptyPlaceholder: null,
      currentViewId: null,
      ticketList: [],
      recordCount: 0, //列表总条数
      searchData: JSON.parse(JSON.stringify(_defaultSearchData)),

      page: {
        pageNumber: 1,
        pageSize: 20
      },
    };
  },

  methods: {
    selectionChange( _val ) {
      this.$refs.TicketBatchOperationBar.selectionChange( _val );
    },

    doExport( _command ) {
      var _type = ( _command && _command.type ) ? _command.type : 'xls';
      var _withForm = ( _command && _command.withForm ) ? _command.withForm : null; // 是否导出表单

      var _filter = encodeURIComponent(JSON.stringify(this.criteria(this.searchData)));

      window.open("/ticket/" + _type + "?viewId=" + this.currentViewId + '&withForm=' + _withForm + "&filter=" + _filter);
    },

    doSearch() {
      localStorage.setItem(CacheUtil.SearchData, JSON.stringify(this.searchData)); // 记住搜索条件
      localStorage.setItem(CacheUtil.TicketViewId, this.currentViewId);

      this.queryTicketList(1);
    },

    resetSearch() {
      localStorage.removeItem(CacheUtil.SearchData); // 清理记住的搜索条件

      this.searchData = JSON.parse(JSON.stringify(_defaultSearchData));

      this.queryTicketList(1);
    },

    handleSizeChange( pageSize ) { // 每页条数改变时执行回调
      this.page.pageSize = pageSize;

      // localStorage
      localStorage.setItem(CacheUtil.TicketViewPageSize, pageSize);

      this.queryTicketList(1);
    },

    tableSortChange_2(e) {
      if ( !e.order ) {
        return;
      }

      if ( 'ascending' == e.order ) {
        this.page.orderBy = '`' + e.prop + '` ASC';
        this.queryTicketList(1);
        return;
      }

      if ( 'descending' == e.order ) {
        this.page.orderBy = '`' + e.prop + '` DESC';
        this.queryTicketList(1);
        return;
      }
    },

    load_searchData_from_localStorage() {
      var _searchData = localStorage.getItem(CacheUtil.SearchData);
      if ( !!_searchData ) {
        this.searchData = JSON.parse(_searchData);
      }

      // console.log('#134 load_searchData_from_localStorage', this.searchData);
      this.$refs.ticketSearchForm.setSearchData(this.searchData);
    },

    // 列表查询 先清空在拉数据
    queryTicketList_2(_pageNumber, _pageSize) {
      this.ticketList = [];

      this.queryTicketList(_pageNumber, _pageSize);
    },

    // 列表查询 不清空
    queryTicketList(_pageNumber, _pageSize) {
      var _this = this;

      var localStorageProjectId = localStorage.getItem(CacheUtil.ProjectId);
      var localStorageViewId = localStorage.getItem(CacheUtil.TicketViewId);

      // 必须有,避免查出所有了
      if ( !localStorageViewId && !localStorageProjectId) {
        console.log('#152 localStorageViewId & localStorageProjectId is null');
        return;
      }

      _this.currentViewId = localStorageViewId;

      _this.tableEmptyPlaceholder = '正在加载工单列表 ...';

      var _searchData = localStorage.getItem(CacheUtil.SearchData);
      if(!!_searchData) {
        _this.searchData = JSON.parse(_searchData);
      }


      if(!_pageSize) {
        _pageSize = localStorage.getItem(CacheUtil.TicketViewPageSize);
      }

      if(!!_pageSize) {
        _this.page.pageSize = Number(_pageSize);
      }

      _this.searchData.orderSuperType = _this.id;
      _this.page.pageNumber = _pageNumber || 1; // 请求参数

      // 有 但可能不用
      var parameterViewId =_this.currentViewId;
      var _filter = _this.criteria(_this.searchData);
      if ( !!_this.$route.query['_filter'] ) {
        _filter = { $and : [_filter || {}, _this.$route.query['_filter'] ] };
        parameterViewId = null; // 如果指定了 _filter 就不用 _viewId 筛选
      }

      // 在项目界面 就根据项目筛选工单
      if ( !!this.$route.query.ticketType // 
        && 98 == this.$route.query.ticketType // 
        && !!localStorageProjectId ) {
        _filter = { $and : [ _filter || {}, { $in_project: localStorageProjectId} ] };
        parameterViewId = null; // 如果指定了项目 就不用 _viewId 筛选
      }

      // 查询工单
      sdk.TicketApi().list({
        viewId: parameterViewId,
        filter: _filter,
        page: _this.page
      }).then(res => {
        _this.ticketList = res.list;
        _this.recordCount = res.recordCount;

        _this.tableEmptyPlaceholder = null;
      });
    }
  },

  mounted() {
    var _this = this;

    setTimeout(() => {
      _this.queryTicketList(); // 加载数据

      _this.load_searchData_from_localStorage();
    }, 500);
  }
};
</script>

<style>
.el-table-column--selection label {
  margin: 0;
  padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/ViewTicketList.vue